/** The websocket room paths, the GM operator header, and the protocol version. */

export const WS_PATH = "/ws" as const;
/**
 * The roster room's websocket path — a *separate* room from the encounter `/ws`
 * (roster is a distinct state domain). The encounter and roster
 * rooms share the same generic command-bus machinery but never the same socket,
 * state, or undo stacks; keeping the paths apart is what keeps the encounter
 * path untouched while the roster room rides the same shapes.
 */
export const WS_ROSTER_PATH = "/ws/roster" as const;
/**
 * The encounter room's websocket path — the *third* state domain's room,
 * parallel to the presence `/ws` and the roster
 * `/ws/roster`. Unlike those single global rooms, encounter rooms are
 * **per-encounter**: the path is the same for every room, and the specific room
 * a client joins is named by the `encounterId` in the join handshake (the
 * per-room seam — room management/permissions are deferred). The
 * three rooms share the generic command-bus machinery but never the same socket,
 * state, or undo stacks.
 */
export const WS_ENCOUNTER_PATH = "/ws/encounter" as const;
/**
 * The **Game room's** websocket path — the durable-game
 * login/authentication room. A client connects here *first* (after fetching the
 * slot list over REST), sends a `game_hello` to claim a slot (or authenticate as
 * the GM operator), and the server replies `game_welcome` (issuing/reclaiming a
 * remembered token + sending the full `GameState` and the slot's standing
 * view-state) or `game_reject`. It is the **identity gate** for the other rooms:
 * the `actorId` a client uses on `/ws/roster` and `/ws/encounter` is the slot id
 * the Game room authenticated it as. The four rooms share the generic command-bus
 * machinery but never the same socket, state, or undo stack.
 */
export const WS_GAME_PATH = "/ws/game" as const;
/** The header carrying the GM host key on a mutating scene request (PUT/DELETE). */
export const HOST_KEY_HEADER = "x-lvtt-host-key" as const;
export const PROTOCOL_VERSION = 1 as const;